export default "__VITE_ASSET__Bo$JUbIz__"